import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ISubscription, ISubscriptionFilter } from "./subscriptions.interface";
import * as _ from 'lodash';
import { HttpService } from "../../../../http.service";
import { UtilsService } from "../../../shared/services/utils.service";
import { apiURL, EnvConfig } from "../../../../env-config";

@Injectable()
export class SubscriptionsService {
  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
  ) { }

  getSubscriptions(filter?: ISubscriptionFilter): Observable<any> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_SUBSCRIPTIONS)}${queryParams}`);
  }

  getSubscription(subscription: ISubscription | string): Observable<any> {
    let id = (typeof subscription == 'string') ? subscription : subscription._id;
    return this._http.get(`${apiURL(EnvConfig.API_SUBSCRIPTIONS)}/${id}`);
  }

  createSubscription(subscription: ISubscription): Observable<any> {
    return this._http.post(`${apiURL(EnvConfig.API_SUBSCRIPTIONS)}`, subscription);
  }

  updateSubscription(subscription: ISubscription): Observable<any> {
    let id = subscription._id;
    delete subscription._id;
    return this._http.patch(`${apiURL(EnvConfig.API_SUBSCRIPTIONS)}/${id}`, subscription);
  }

  deleteSubscription(subscription: ISubscription | string, hardDelete: boolean = false): Observable<void> {
    let id = (typeof subscription == 'string') ? subscription : subscription._id;
    if (hardDelete) return this._http.delete(`${apiURL(EnvConfig.API_SUBSCRIPTIONS)}/${id}`);
    return this._http.delete(`${apiURL(EnvConfig.API_SUBSCRIPTIONS)}/${id}/delete`);
  }

  restoreSubscription(subscription: ISubscription | string): Observable<void> {
    let id = (typeof subscription == 'string') ? subscription : subscription._id;
    return this._http.post(`${apiURL(EnvConfig.API_SUBSCRIPTIONS)}/${id}/restore`, null);
  }
}